import React from 'react';
import ImageUploader from './ImageUploader';

function TestCase({ 
  testCase, 
  testCaseIndex, 
  onUpdateTestCase,
  onRemoveTestCase,
  isCollapsed,
  onToggleCollapse,
  onImageUpload,
  planId,
  onImageClick
}) {
  const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  
  return (
    <div className="step-item" style={{ marginBottom: '1rem' }}>
      <div 
        className="step-header" 
        onClick={onToggleCollapse}
        style={{ 
          cursor: 'pointer', 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          padding: '1rem',
          backgroundColor: isDarkMode ? '#374151' : '#f8fafc',
          border: `1px solid ${isDarkMode ? '#4b5563' : '#e2e8f0'}`,
          borderRadius: '8px 8px 0 0',
          borderBottom: isCollapsed ? `1px solid ${isDarkMode ? '#4b5563' : '#e2e8f0'}` : 'none',
          color: isDarkMode ? '#e5e7eb' : '#1f2937'
        }}
      >
        <div>
          <strong>{testCase.title || `Test Case ${testCaseIndex + 1}`}</strong>
          <span style={{ marginLeft: '0.5rem', fontSize: '0.875rem', color: isDarkMode ? '#9ca3af' : '#6b7280' }}>
            🧪 Test Case • {testCase.id || 'No ID'}
          </span>
        </div>
        <div style={{ fontSize: '1.2rem' }}>
          {isCollapsed ? '▶' : '▼'}
        </div>
      </div>
      
      {!isCollapsed && (
        <div 
          className="step-content" 
          style={{
            border: `1px solid ${isDarkMode ? '#4b5563' : '#e2e8f0'}`,
            borderTop: 'none',
            borderRadius: '0 0 8px 8px',
            padding: '1.5rem',
            backgroundColor: isDarkMode ? '#1f2937' : '#ffffff'
          }}
        >
          <div className="form-group">
            <label>Test Case ID</label>
            <input
              type="text"
              className="form-control"
              value={testCase.id}
              onChange={(e) => onUpdateTestCase(testCaseIndex, 'id', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Test Case Title</label>
            <input
              type="text"
              className="form-control"
              value={testCase.title}
              onChange={(e) => onUpdateTestCase(testCaseIndex, 'title', e.target.value)}
              placeholder="e.g., User Authentication Flow"
            />
          </div>
          <div className="form-group">
            <label>Test Case Description</label>
            <textarea
              className="form-control"
              value={testCase.description}
              onChange={(e) => onUpdateTestCase(testCaseIndex, 'description', e.target.value)}
              placeholder="Brief description of what this test case covers"
              rows="2"
            />
          </div>
          <div className="form-group">
            <label>Design Link (Optional)</label>
            <input
              type="url"
              className="form-control"
              value={testCase.design_link || ''}
              onChange={(e) => onUpdateTestCase(testCaseIndex, 'design_link', e.target.value)}
              placeholder="e.g., https://figma.com/design-link"
            />
          </div>
          <div className="form-group">
            <label>Reference Images</label>
            <ImageUploader
              onImageUpload={(files) => onImageUpload(testCaseIndex, files)}
              planId={planId}
              label="📸 Upload test case reference images"
              images={testCase.ui_images || []}
              onImageClick={onImageClick}
            />
          </div>
          <button 
            className="btn btn-danger" 
            onClick={() => onRemoveTestCase(testCaseIndex)}
            style={{ marginTop: '1rem' }}
          >
            🗑️ Remove Test Case
          </button>
        </div>
      )}
    </div>
  );
}

export default TestCase; 